package com.evoapps.evoshift.domain.usecase

import com.evoapps.evoshift.domain.model.AvailabilityRequest
import com.evoapps.evoshift.domain.repository.AvailabilityRepository

class GetAvailabilityRequestUseCase(
    private val availabilityRepository: AvailabilityRepository
) {
    suspend operator fun invoke(requestId: String): Result<AvailabilityRequest> {
        return availabilityRepository.getAvailabilityRequest(requestId)
    }
}
